export enum headerEnum {
  MARKETING_HUB = 'Marketing Hub',
  FINANCE = 'Finance',
  SOCTRIP = "Soctrip",
  TMTRAVEL = "TMTravel",
}
